import websitesService from "@/services/websites";
import serviceHandler from "@/helpers/handlers/service";

export default {
  async getWebsites({ commit }) {
    commit("SET_LOADING", true);

    const data = await serviceHandler(websitesService.getWebsitesData());

    if (data.length > 0) {
      commit("SET_WEBSITES", data);
      return commit("SET_LOADING", false);
    }
  }
};
